<template>
  <div id="user">
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition" >
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px">
              <el-form-item :label="$t('user.name')" >
                <el-input v-model="filterForm.name" :placeholder="$t('user.chooseName')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('user.cellphone')" >
                <el-input v-model="filterForm.cellphone" :placeholder="$t('user.choosePhone')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('filters.region')" >
                <el-select v-model="filterForm.regionNo" :placeholder="$t('filters.chooseRegion')" clearable>
                  <el-option
                    v-for="item in filterRegionOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.reseller')" >
                <el-select v-model="filterForm.resellerNo" :placeholder="$t('filters.chooseReseller')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in resellerOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('filters.subReseller')" >
                <el-select v-model="filterForm.subReseller" :placeholder="$t('filters.chooseSubReseller')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in subResellerOptions"
                    :key="item.itemKey"
                    :label="item.itemValue"
                    :value="item.itemKey">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('user.role')" >
                <el-select v-model="filterForm.roleCode" :placeholder="$t('user.chooseRole')" @visible-change="resetFilters()">
                  <el-option
                    v-for="item in roleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="16">
                <div class="filterBtns">
                  <!--
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="exportData">导 出</el-button>
                  -->
<!--                  <el-button type="primary" @click="onAdd">{{ $t('user.add') }}</el-button>-->
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onReset()">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="filterBtns">
                  <el-button type="primary" @click="importData">导 入</el-button>
                  <el-button type="primary" @click="onAdd">新增人员</el-button>
                  <el-button type="primary" @click="onAddAdmin">新增公众号管理员</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="tableLoading"
            >
              <el-table-column
                fixed
                prop="name"
                :label="$t('user.name')"
              >
              </el-table-column>
              <el-table-column
                prop="cellphone"
                :label="$t('user.cellphone')">
              </el-table-column>
              <el-table-column
                prop="regionName"
                :label="$t('filters.region')"
              >
              </el-table-column>
              <el-table-column
                prop="doorName"
                :label="$t('filters.doorName')"
              >
              </el-table-column>
              <el-table-column
                prop="posId"
                label="门店编号"
              >
              </el-table-column>
              <el-table-column
                prop="resellerName"
                :label="$t('filters.reseller')"
              >
              </el-table-column>
              <el-table-column
                prop="subResellerName"
                :label="$t('filters.subReseller')"
              >
              </el-table-column>
              <el-table-column
                prop="roleName"
                :label="$t('user.role')"
              >
              </el-table-column>
              <el-table-column
                :label="$t('operation')"
                width="120">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.roleCode === 'MM' || scope.row.roleCode === 'TTT'" @click="editUser(scope.row)" type="text" size="small">{{ $t('edit') }}</el-button>
                  <el-button @click="deleteUser(scope.row)" type="text" size="small">{{ $t('delete') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination
                background
                @current-change="currentChange"
                :current-page="tableConfig.current"
                layout="total, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <el-dialog
      :title="$t('user.addPublicAdmin')"
      :visible.sync="CreateAdminDialogVisible"
      width="40%"
      center
    >
      <el-form
        :model="adminUserForm"
        ref="adminUserForm"
        label-width="100px"
        class=""
      >
        <el-form-item :label="$t('user.cellphone')" prop="cellphone">
          <el-input :placeholder="$t('user.choosePhone')" @input="queryPhone" v-model="adminUserForm.cellphone">
            <template slot="append"><el-button slot="append" icon="el-icon-search" @click="queryPhone"></el-button></template>
          </el-input>
          <!--          <el-select v-model="userForm.resellerNo" :placeholder="$t('filters.chooseReseller')" style="width: 100%">-->
          <!--            <el-option-->
          <!--              v-for="item in resellerOptions"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
        </el-form-item>
        <el-form-item :label="$t('user.role')" prop="role" >
          <span>{{ adminUserForm.role }}</span>
        </el-form-item>
        <el-form-item :label="$t('filters.doorName')" prop="doorName" >
          <span>{{ adminUserForm.doorName }}</span>
        </el-form-item>
        <el-form-item label="门店编号" prop="posId" >
          <span>{{ adminUserForm.posId }}</span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAdminUser">{{ $t('save') }}</el-button>
        <el-button type="primary" @click="CreateAdminDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('user.add')"
      :visible.sync="CreateDialogVisible"
      width="40%"
      center
    >
      <el-form
        :model="userForm"
        ref="userForm"
        label-width="100px"
        class=""
      >
        <el-form-item :label="$t('user.cellphone')" prop="cellphone">
          <el-input :placeholder="$t('user.choosePhone')" @input="queryPhone" v-model="userForm.cellphone">
            <template slot="append"><el-button slot="append" icon="el-icon-search" @click="queryPhone"></el-button></template>
          </el-input>
          <!--          <el-select v-model="userForm.resellerNo" :placeholder="$t('filters.chooseReseller')" style="width: 100%">-->
          <!--            <el-option-->
          <!--              v-for="item in resellerOptions"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
        </el-form-item>
        <div class="roleName">{{ userForm.roleName }}</div>
        <div class="roleCode" v-if="this.showRole">
          <el-radio-group v-model="userForm.roleCode">
            <p v-for="(role, index) in roleOptions" :key='index' >
              <el-radio :label="role.value" :disabled="disableRole">{{ role.label }}</el-radio>
            </p>
          </el-radio-group>
        </div>
        <el-form-item :label="$t('filters.reseller')" prop="resellerNo" v-if="userForm.roleCode === 'NikeInternalClient' || showReseller">
          <el-select v-model="userForm.resellerNo" :placeholder="$t('filters.chooseReseller')" style="width: 100%">
            <el-option
              v-for="item in resellerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.subReseller')" prop="resellerNo" v-if="userForm.roleCode === 'NikeInternalClient' || showReseller">
          <el-select v-model="userForm.subResellerNo" :placeholder="$t('filters.chooseSubReseller')" style="width: 100%">
            <el-option
              v-for="item in subResellerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('filters.region')" prop="regionNo" v-if="this.showRegion">
          <el-select v-model="userForm.regionNo" :placeholder="$t('filters.chooseRegion')" style="width: 100%" clearable>
            <el-option
              v-for="item in regionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUser">{{ $t('save') }}</el-button>
        <el-button type="primary" @click="CreateDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('user.edit')"
      :visible.sync="EditDialogVisible"
      width="40%"
      center
    >
      <el-form
        :model="userForm"
        ref="userForm"
        label-width="100px"
        class=""
      >
        <el-form-item :label="$t('user.role')" prop="roleName">
          <el-input
            v-model="userForm.roleName"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('user.cellphone')" prop="cellphone">
          <el-input
            v-model="userForm.cellphone"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('filters.region')" prop="regionNo">
          <el-select style="width: 100%" v-model="userForm.regionNo" :placeholder="$t('filters.chooseRegion')" clearable>
            <el-option
              v-for="item in regionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUser">{{ $t('save') }}</el-button>
        <el-button type="primary" @click="EditDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('failureList')"
      :visible.sync="failureDialogVisible"
      width="70%"
      center
    >
      <el-table
        :data="failureTableData"
        style="width: 100%">
        <el-table-column
          prop="name"
          :label="$t('user.name')"
        >
        </el-table-column>
        <el-table-column
          prop="cellphone"
          :label="$t('user.cellphone')"
        >
        </el-table-column>
        <el-table-column
          prop="role"
          :label="$t('user.role')">
        </el-table-column>
        <el-table-column
          prop="regionName"
          :label="$t('filters.region')">
        </el-table-column>
        <el-table-column
          prop="resellerName"
          :label="$t('filters.reseller')">
        </el-table-column>
        <el-table-column
          prop="subResellerName"
          :label="$t('filters.subReseller')">
        </el-table-column>
        <el-table-column
          prop="failureReason"
          :label="$t('failureReason')"
          width="280"
          fixed="right"
        >
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadFailure">{{ $t('download') }}</el-button>
        <el-button type="primary" @click="failureDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'User',
  components: {
  },
  data: function () {
    return {
      radio: '1',
      failureTableData: false, // 导入失败列表数据
      failureDialogVisible: false, // 导入失败列表弹窗
      CreateAdminDialogVisible: false, // 新增公众号管理员
      CreateDialogVisible: false, // 新增人员
      EditDialogVisible: false, // 编辑人员
      filterForm: {
      },
      initFilterForm: {
        cellphone: '', // 手机号
        regionNo: '', // 区域
        name: '', // 姓名
        reseller: '', // 客户
        subReseller: '', // 二级客户
        roleCode: '', // 角色
      },
      userForm: {
      },
      initUserForm: {
        cellphone: '', // 手机号
        regionNo: '', // 区域
        roleName: '', // 角色
        resellerNo: '', // 客户
        subResellerNo: '', // 二级客户
        roleCode: '', // 角色code
        id: 0, // 用户id
        name: '', // 用户name
        account: '' // 用户account
      },
      adminUserForm: {},
      initAdminUserForm: {
        cellphone: '', // 手机号
        roleCode: '', // 角色code
        doorName: '', // 门店
        posId: '', // posId
      },
      filterRegionOptions: [],
      regionOptions: [],
      resellerOptions: [],
      subResellerOptions: [],
      roleOptions: [],
      adminOptions: [{
        label: '是admin',
        value: 1
      },
        {
          label: '非admin',
          value: 0
        }],
      tableData: [], // 表格数据
      total: 0,
      tableConfig: {
        size: 10, // 每页数量
        current: 1 // 当前页码
      },
      tableLoading: false,
      showRegion: false,
      showReseller: false,
      showRole: false,
      disableRole: false // 新增时是否禁用选择角色
    }
  },
  mounted () {
    this.getRangList()
    this.getOptions({})
    this.onReset()
  },
  methods: {
    downloadFailure: function() {
      // todo: 下载导入失败列表
    },
    submitAdminUser: function() {
      // todo: 保存公众号管理员用户
    },
    resetFilters: function () {
      this.getRangeList()
    },
    getRangeList: async function (clear) {
      let filterParams = {
        'cityNo': this.filterForm.cityNo,
        'resellerNo': this.filterForm.resellerNo,
        'subReseller': this.filterForm.subReseller,
        'provinceNo': this.filterForm.provinceNo,
        'regionNo': this.filterForm.regionNo,
      }
      let submitParams = this.$tool.formatArrayToString(filterParams)
      if (clear) {
        submitParams = {}
      }
      let res = await window.instance.post(window.retailogUrl + '/account/common', submitParams)
      console.log('res', res)
      res = res.data.data
      this.regionOptions = res.regionList
      this.provinceOptions = res.provinceList
      this.cityOptions = res.cityList
      this.resellerOptions = res.resellerList
      this.subResellerOptions = res.subResellerList
    },
    // 获取弹窗里的区域,客户,角色列表
    getOptions: async function (params) {
      let res = await window.instance.post(window.surveyUrl + '/condition/user', params)
      console.log('res', res)
      res = res.data.data
      this.regionOptions = _.map(res.regionList, (item) => ({label: item.itemValue, value: item.itemKey}))
      this.roleOptions = _.map(res.roleList, (item) => ({label: item.itemValue, value: item.itemKey}))
      this.resellerOptions = _.map(res.resellerList, (item) => ({label: item.itemValue, value: item.itemKey}))
    },
    // 获取筛选条件的区域,地区列表
    getRangList: async function () {
      let res = await window.instance.post(window.retailogUrl + '/account/common', {})
      res = res.data.data
      this.filterRegionOptions = res.regionList
      this.locateOptions = res.locateList
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      this.tableLoading = true
      let res = await window.instance.post(window.surveyUrl + '/account/list', _.assign(this.filterForm, this.tableConfig))
      res = res.data
      if (res.code === 200) {
        const list = res.data.list
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
    currentChange: function (index) {
      // 分页
      this.tableConfig.current = index
      this.onSearch(false)
    },
    onReset: function () {
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },
    onAdd: function () {
      this.CreateDialogVisible = true
      this.userForm = _.cloneDeep(this.initUserForm)
      this.showRegion = false
      this.showReseller = false
      this.showRole = false
    },
    onAddAdmin: function () {
      this.CreateAdminDialogVisible = true
      this.adminUserForm = _.cloneDeep(this.initAdminUserForm)
    },
    editUser: function (user) {
      this.EditDialogVisible = true
      this.userForm = {
        id: user.id,
        cellphone: user.cellphone,
        roleName: user.roleName,
        roleCode: user.roleCode,
        resellerNo: user.resellerNo,
        resellerName: user.resellerName,
        regionNo: user.regionNo,
        name: user.name,
        account: user.account,
        locateOf: _.toString(user.locateOf)
      }
    },
    deleteUser: function (user) {
      const tipContent = this.$t('user.deleteUser') + '?'
      const tip = this.$t('tip')
      this.$confirm(tipContent, tip, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      })
        .then(async () => {
          let res = await window.instance.post(window.surveyUrl + '/account/delete', {id: user.id})
          res = res.data
          if (res.code === 200) {
            await this.onSearch(false)
            this.$message.success(res.message)
          } else {
            // this.$message.warning(res.message)
          }
        })
        .catch(_ => {})
    },

    submitUser: async function () {
      if (this.userForm.roleCode === 'NikeInternal') {
        this.$message.warning(this.$t('user.chooseRole'))
        return false
      }
      this.EditDialogVisible = false
      this.CreateDialogVisible = false
      // 新建/编辑用户保存
      const regionName = this.getSelectedName(this.userForm.regionNo, this.regionOptions)
      const resellerName = this.getSelectedName(this.userForm.resellerNo, this.resellerOptions)
      console.log('this.userForm.roleCode', this.userForm.roleCode)
      console.log('this.roleOptions', this.roleOptions)
      const roleName = this.getSelectedName(this.userForm.roleCode, this.roleOptions)
      let res = await window.instance.post(window.surveyUrl + '/account/save', _.assign(this.userForm, {regionName, resellerName, roleName: roleName || this.userForm.roleName}))
      res = res.data
      if (res.code === 200) {
        await this.onSearch()
        this.$message.success(res.message)
      }
    },

    queryPhone: async function () {
      if (this.userForm.cellphone.length > 7) {
        let res = await window.instance.get(window.surveyUrl + '/account/publicInfo?cellphone=' + this.userForm.cellphone)
        res = res.data
        if (res.code === 200) {
          console.log('用户手机号查询', res.data)
          const roleCode = res.data.roleCode
          let showRegion = false
          let showReseller = false
          let showRole = false
          this.userForm.roleCode = res.data.roleCode
          this.userForm.roleName = res.data.roleName
          this.userForm.resellerNo = res.data.resellerNo
          this.userForm.regionNo = res.data.regionNo
          this.userForm.account = res.data.account
          switch (roleCode.toUpperCase()) {
            case 'MM':
              showRegion = true
              this.userForm.regionNo = null
              break
            case 'TTT':
              showRegion = true
              break
            case 'NIKEINTERNAL':
              showRole = true
              this.getOptions({
                regionNo: res.data.regionNo,
                roleCode: res.data.roleCode
              })
              break
            case 'HEADQUARTER':
              showRole = false
              showReseller = true
              await this.getOptions({
                regionNo: res.data.regionNo,
                roleCode: res.data.roleCode
              })
              this.userForm.resellerNo = res.data.resellerNo || this.resellerOptions[0].value
              break
            default:
              break
          }
          this.userForm.roleName = res.data.roleName
          this.userForm.name = res.data.name
          this.showRegion = showRegion
          this.showReseller = showReseller
          this.showRole = showRole
        }
      }
    },

    // todo: 导入用户
    importData: function () {

      // 如果失败的话,弹出失败列表
      this.failureDialogVisible = true
      this.failureTableData = [{
        name: '张三',
        role: '角色',
        cellphone: '13888888888',
        regionName: '大北京',
        resellerName: '客户',
        subResellerName: '二级客户',
        failureReason: '失败原因'
      }]
    },
    // todo: 导出用户
    exportData: function () {
    },
    getSelectedName: function (no, list) {
      if (!no) {
        return null
      }
      const selectedReseller = _.find(list, function (data) { return data.value === no })
      if (selectedReseller) {
        return selectedReseller.label
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped lang="sass">
#user
  .roleName
    color: #ff6801
    margin-left: 32px
    margin-bottom: 20px
  .roleCode
    margin-left: 32px
    margin-bottom: 14px
    label
      padding: 5px 0
</style>



// WEBPACK FOOTER //
// src/pages/wo/userManage.vue